export default __webpack_public_path__ + "static/media/cp_geo_gr.ee8135c6.svg";